import { render, staticRenderFns } from "./QuestionAccordion.vue?vue&type=template&id=2e7205fd&scoped=true&"
import script from "./QuestionAccordion.vue?vue&type=script&lang=js&"
export * from "./QuestionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAccordion.vue?vue&type=style&index=0&id=2e7205fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7205fd",
  null
  
)

export default component.exports